const ZIP_CODE = 'zipCode';
const LIVING_AREA = 'livingArea';
const PLOT_AREA = 'area';
const ROOMS = 'rooms';

export default {
  ZIP_CODE,
  LIVING_AREA,
  PLOT_AREA,
  ROOMS,
};
